'use strict';

angular.module('accessRequestModule')

.config(function ($stateProvider, resourceStateProvider) {

    resourceStateProvider
        .state('admin.access-requests', {
            url: 'access-requests',
            model: 'AccessRequest',
            viewOptions: 'accessRequestViewOptions',
            title: 'Access Request',
            root: {
                onEnter: ['appConfig', '$state', 'kdGate', function (appConfig, $state, kdGate) {
                    if (!appConfig.accessRequest.enabled || !kdGate.allows('user-management.users')) {
                        $state.go('admin.welcome', {}, {location: "replace"});
                    }
                }]
            },
            edit: {
                templateUrl: 'access.request/access-request.edit.html',
                controller: 'AccessRequestsCtrl',
                controllerAs: '$ctrl',
                resolve: {
                    model: ['AccessRequest', 'modalState', '$q', function (AccessRequest, modalState, $q)
                    {
                        var paramId = parseInt(modalState.stateParams.id);

                        if (!paramId) {
                            modalState.model = AccessRequest.createInstance();
                            return modalState.model;
                        }

                        return AccessRequest.find(paramId, {
                            params: {
                                with: 'actions,user.role'
                            }
                        }).then(function (model) {
                            modalState.model = model;
                            return model;
                        }, function (reason) {
                            return $q.reject('Access Request not found with id [' + paramId + '].', reason);
                        });
                    }],
                    actions: ['Action', function (Action) {
                        return Action.findAll({
                            sort: [['group', 'ASC']]
                        });
                    }],
                    roles: ['Role', function (Role) {
                        return Role.findAll({
                            with: 'permissions',
                            limit: 10000,
                        });
                    }],
                }
            },
            move: false
        });

    $stateProvider.state('guest.access-request', {
            url: '/access-request',
            templateUrl: 'access.request/accessRequest.html',
            onEnter: ['appConfig', '$state', function (appConfig, $state) {
                if (!appConfig.accessRequest.enabled) {
                    $state.go('guest.login');
                }
            }],
        });
});
